import * as actions from '../actions'

var defaultState = null

export default function app(state = defaultState, action) {
    let newState = state

    switch (action.type) {
        case actions.APP_SELECT:
            return action.payload

        case actions.APP_GET_ONE:
        case actions.APP_GET_ONE_CODENAME:
            newState = state
            if (!action.error) {
                newState = action.payload.data
            }
            return newState

        case actions.APP_ADD:
            newState = state
            if (!action.error) {
                newState = defaultState // So we force-reload when getting back to a list of apps
            }
            return newState

        case actions.APP_CLEAN_ONE:
            return defaultState

        default:
            return state
    }
}
